import { type EventContentObjectDetail, createEventContentObject } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import type { EventContentObjectDataObject } from 'models/service';

import { getEvent } from '../services';

import { getEventDetailQueryKey } from './keys';

type P = {
  id?: string;
  options?: Partial<UseQueryOptions<EventContentObjectDetail, ApiClientResponseError<ResponseErrorDataObject>>>;
};

export const useEventQuery = ({ id, options }: P) =>
  useQuery<EventContentObjectDetail>({
    enabled: Boolean(id),
    async queryFn() {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- this will run only if eventId is defined
      const { data: eventContenObject } = await getEvent<EventContentObjectDataObject>(id!);

      return createEventContentObject(eventContenObject);
    },
    queryKey: getEventDetailQueryKey({ id, view: 'internal' }),
    throwOnError: true,
    ...options,
  });
